/*
  适配ListView filter组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import { SelectTree } from '@tencent/spaui-business';
import { connect } from 'react-redux';
import _ from 'lodash';
import './IndustryInfo.scoped.less';

const extraIndustryData = [
  {
    className: '',
    desc: '未知行业',
    value: 0,
  },
  {
    className: '',
    desc: '空',
    value: 'null',
  },
];

class IndustrySelectFilter extends React.Component {
  static propTypes = {
    rootList: PropTypes.arrayOf(PropTypes.shape({
      industryId: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    })).isRequired,
    industryList: PropTypes.arrayOf(PropTypes.shape({
      industryId: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    })).isRequired,
    withDeprecatedMark: PropTypes.bool, // 废弃行业标记
    deprecatedDisabled: PropTypes.bool, // 废弃行业禁用
    onChange: PropTypes.func,
    level1Disable: PropTypes.bool, // 是否禁用一级行业
  }

  state = {
    searchValue: '',
    searchValueData: undefined,
  }

  getIndustryName(industryIds) {
    const { industryRepo } = this.props;
    return _.map(industryIds, (industryId) => {
      const industry = industryRepo[industryId];
      const parent =  industry && industry.parentId !== 0 ? industryRepo[industry.parentId] : undefined;
      const firstText  = parent && parent.level > 0 ? parent.displayName : '';
      const secondText = industry.displayName;
      return firstText ? `${firstText}/${secondText}` : secondText;
    }).join(',');
  }

  render() {
    const { rootList, industryList, value, onChange, config = {} } = this.props;
    const { level1Disable, extraIndustry = false } = config || {};

    const data = _.map(rootList, (parent) => {
      return {
        value: level1Disable ? '' : parent.industryId,
        desc: parent.label,
        isdisabled: parent.status,
        className: parent.className,
        options: _.map(
          _.filter(industryList, (industry) => industry.parentId === parent.industryId),
          (child) => {
            return {
              value: child.industryId,
              desc: child.label,
              className: child.className,
              isdisabled: child.status,
            };
          },
        ),
      };
    });
    // 前端添加额外行业选项
    if (extraIndustry) {
      data.push(...extraIndustryData);
    }
    const { searchValue, searchValueData } = this.state;
    return (
      <SelectTree
        {...config}
        className="IndustrySelectFilter"
        clearable
        data={data}
        value={value || []}
        onChange={(e, value) => {
          onChange?.({ text: this.getIndustryName(value), value });
        }}
        canSelected={this.canSelected}
        onSearch={this.onSearch}
        searchValue={searchValue}
        searchValueData={searchValueData}
      />
    );
  }

  canSelected = (treeNode, defaultAllowSelected) => {
    const { deprecatedDisabled = false, level1Disable } = this.props;
    if (treeNode.deepLevel === 1) {
      if (level1Disable) return false;
      return true;
    }
    if (!deprecatedDisabled) return true;
    if (treeNode.isdisabled === 'active' || treeNode.isdisabled === 'pre_deprecated') {
      return true;
    } if (treeNode.isdisabled === 'deprecated') {
      return false;
    }
  }

  onSearch = (e, value) => {
    value = value.trim();
    const { industryList, deprecatedDisabled } = this.props;
    const searchValueData = _.map(
      _.filter(industryList, (v) => _.includes(v.label, value)),
      (industry) => {
        return {
          value: industry.industryId,
          label: industry.label,
          disabled: deprecatedDisabled && industry.status === 'deprecated',
        };
      },
    );
    this.setState({ searchValue: value, searchValueData: !value ? undefined : searchValueData });
  }
}

function mapStateToProps(state, ownProps) {
  const statusNameMap = {
    active: '',
    pre_deprecated: '（预废弃）',
    deprecated: '（废弃）',
  };
  const industryList = _.map(_.map(state.industryList.items, (industryId) => state.industryRepo[industryId]), (item) => {
    const label = `${item.displayName}${statusNameMap[item.status] || ''}`;
    return {
      ...item,
      label: ownProps.withDeprecatedMark ? label : item.displayName,
      className: ownProps.deprecatedDisabled && item.status === 'deprecated' ? 'deprecated' : '',
    };
  });
  return {
    rootList: _.filter(industryList, (industry) => industry.level === 1),
    industryList,
    industryRepo: state.industryRepo,
  };
}

export default connect(mapStateToProps)(IndustrySelectFilter);
